module.exports = __webpack_public_path__ + "static/media/star_inActive.cdfd0644.svg";